import React from "react";
import { Link } from "react-router-dom";
function nav() {
  return (
    <nav className="black">
      <div className="nav-wrapper">
        <Link to="/">
          <li className="brand-logo center bold poppins">DarkHub</li>
        </Link>
        <ul class="right ">
          <li>
            <Link to="/about">
              <span>About Me</span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default nav;
